import { useQuery } from '@tanstack/react-query';

import { ShortUrl } from '@air/api';
import { type Board, type ShortUrl as ShortUrlType } from '@air/api/types';
import { useShortIdContext } from '@air/provider-short-id';

const PUBLIC_FILTER_OPTIONS = 'PUBLIC_FILTER_OPTIONS';

export const getPublicFiltersOptionsKey = (
  shortId: ShortUrlType['id'] | undefined,
  boardId: Board['id'] | undefined,
) => [PUBLIC_FILTER_OPTIONS, { shortId, boardId }];

export const useGetPublicFilterOptions = ({ boardId }: { boardId: Board['id'] | undefined }) => {
  const { shortId } = useShortIdContext();

  return useQuery({
    queryKey: getPublicFiltersOptionsKey(shortId, boardId),
    queryFn: () => ShortUrl.getFilterLookupsForShortId(shortId, boardId),
    enabled: !!boardId,
  });
};
